<template>
    <div>
        test
    </div>
</template>

<script>
    import {Component, Vue} from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class BillingUser extends Vue{


    }
</script>

<style scoped>

</style>
